import ApiService from "../../../services/ApiService";
import Logger from "../../../services/Logger";

const VocabularyService = {
    /**
     * GET /home/vocabulary — paginated saved words for the current user.
     * @param {number} page
     * @param {number} pageSize
     * @returns {Promise<{ content: Array, totalElements: number, totalPages: number }>}
     */
    getVocabulary: async (page = 0, pageSize = 20) => {
        try {
            const params = { page, pageSize };
            const response = await ApiService.getData("/home/vocabulary", params);
            Logger.log("Vocabulary response:", response);

            if (response && typeof response === "object") {
                if (response.code === "FAILURE" || response.error) {
                    throw new Error(response.message || response.error || "Failed to fetch vocabulary");
                }

                let content = [];
                if (Array.isArray(response.content)) {
                    content = response.content;
                } else if (Array.isArray(response)) {
                    content = response;
                }

                const totalElements = response.totalElements ?? content.length;
                const totalPages =
                    response.totalPages ?? Math.max(1, Math.ceil(totalElements / pageSize));

                return { content, totalElements, totalPages };
            }

            return { content: [], totalElements: 0, totalPages: 0 };
        } catch (error) {
            Logger.error("Error fetching vocabulary:", error);
            throw error;
        }
    }
};

export default VocabularyService;
